/**
 * Компонент круглой кнопки чата в правом нижнем углу
 */

import React, { useState, useEffect } from 'react';
import { useChatContext } from './ChatContext';
import './ChatButton.css';

const ChatButton = ({ pulse = true }) => {
    const { openChat, isOpen } = useChatContext();
    const [shouldPulse, setShouldPulse] = useState(pulse);

    // Опционально: отключить пульсацию через несколько секунд после загрузки
    useEffect(() => {
        if (pulse) {
            const timer = setTimeout(() => {
                setShouldPulse(false);
            }, 10000); // Пульсация 10 секунд после загрузки
            
            return () => clearTimeout(timer);
        }
    }, [pulse]);

    // Скрыть кнопку когда чат открыт
    if (isOpen) return null;

    return (
        <button 
            className={`chat-button ${shouldPulse ? 'chat-button_pulse' : ''}`}
            onClick={openChat}
            aria-label="Открыть чат"
        >
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="#272727"
                    d="M14 6h20a8 8 0 0 1 8 8v12a8 8 0 0 1-8 8H22l-8.4 7.1c-.55.46-1.35.02-1.35-.7V34H14a8 8 0 0 1-8-8V14a8 8 0 0 1 8-8z"
                />
                <rect x="15.5" y="15.2" width="16.5" height="3.6" rx="1.8" fill="#B8FF65"/>
                <rect x="15.5" y="22.4" width="11" height="3.6" rx="1.8" fill="#B8FF65"/>
            </svg>
        </button>
    );
};

export default ChatButton;
